export default function titleCase(str) {
  if (!str) return str;
  return str.replace(/\S+/g, w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
}
